import { assign, DoneInvokeEvent } from "xstate";
import { CheckoutContext } from "./types";

export const persistClientSecret = assign<
  CheckoutContext,
  DoneInvokeEvent<{ client_secret: string }>
>({
  clientSecret: (_, { data }) => data?.client_secret,
});
